export const SidebarItem = ({
  children,
  onClick,
  isStatic
}: {
  children?: any;
  onClick?: () => void;
  isStatic?: boolean;
}) => (
  <div
    className={`sidebar-teaser ${isStatic ? 'sidebar-teaser--static' : ''}`}
    onClick={onClick}
  >
    {children}
  </div>
);

export default SidebarItem;
